import { useDisclosureWithData } from '@/hooks/useDisclosureWithData';
import { FormTypeEnum } from '@/types';

import { useDeleteProgram } from '../api/delete-program';
import { usePatchProgram } from '../api/patch-program';
import { usePostProgram } from '../api/post-program';
import { TProgram, TProgramForm, TProgramPost } from '../types';

type TProgramControllersReturn = {
  programDialog: ReturnType<typeof useDisclosureWithData<TProgram>>;
  programDrawer: ReturnType<
    typeof useDisclosureWithData<{ type: FormTypeEnum; data: TProgram | null }>
  >;
  isPendingCreate: boolean;
  handleDeleteProgram: () => void;
  handleCreateProgram: (data: TProgramForm) => void;
};

export function useProgramControllers(): TProgramControllersReturn {
  const programDialog = useDisclosureWithData<TProgram>();
  const programDrawer = useDisclosureWithData<{ type: FormTypeEnum; data: TProgram | null }>();
  const { mutateAsync: deleteProgram } = useDeleteProgram();
  const { mutateAsync: createProgram, isPending: isPendingCreate } = usePostProgram();
  const { mutateAsync: updateProgram } = usePatchProgram();

  const handleDeleteProgram = () => {
    if (programDialog.data) {
      deleteProgram({
        id: programDialog.data.id,
      }).finally(() => {
        programDialog.close();
      });
    }
  };

  const handleCreateProgram = (data: TProgramForm) => {
    if (!data) return;

    if (data?.id) {
      updateProgram(data as TProgramPost).then(() => {
        programDrawer.close();
      });
    } else {
      createProgram(data as TProgramPost).then(() => {
        programDrawer.close();
      });
    }
  };

  return {
    programDialog,
    programDrawer,
    isPendingCreate,
    handleDeleteProgram,
    handleCreateProgram,
  };
}
